import { isAfter } from 'date-fns';
import { trim } from 'lodash';
import type { MasterPartTemplateDetailsModel, OdataMasterPartTemplates } from 'redux-store/services';

export function validateEmail(email: string) {
  if (!email) {
    return;
  }

  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const emails = email.split(',').map((x) => trim(x));

  let isValid = false;

  for (email of emails) {
    if (re.test(email)) {
      isValid = true;
      continue;
    }
    isValid = false;
    break;
  }

  if (isValid) {
    return undefined;
  }
  return 'Invalid Email';
}

export function validateSlack(url: string) {
  const re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]slack+)\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gim;

  if (re.test(url)) {
    return undefined;
  }

  return 'Required';
}

export function validateTeams(url: string) {
  const re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+(.webhook.office+)\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gim;

  if (re.test(url)) {
    return undefined;
  }

  return 'Required';
}

export function validateIPAddress(ipAddress: string) {
  const re = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

  if (re.test(ipAddress)) {
    return undefined;
  }
  return 'Required';
}

export function validatePort(port: string) {
  const re = /^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;

  if (re.test(port)) {
    return undefined;
  }
  return 'Required';
}

export function validateJobNumber(jobNumber: string) {
  const re = /^[0-9]*$/;

  if (re.test(jobNumber)) {
    return undefined;
  }
  return 'Required';
}

export function validateUrl(url: string) {
  const urlRegex =
    /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/;

  if (urlRegex.test(url)) {
    return undefined;
  }
  return 'Required';
}

export function validateJSON(string: string, nullable?: boolean) {
  if (!string && nullable) {
    return undefined;
  }

  try {
    JSON.parse(string);
  } catch (e) {
    return 'Required';
  }

  return undefined;
}

export function validateExpirationDate(startDate: string, endDate: string) {
  if (!endDate || !startDate) {
    return 'Required';
  }
  if (isAfter(new Date(endDate), new Date(startDate)) && isAfter(new Date(endDate), new Date())) {
    return undefined;
  }

  return 'Date must be after start date and in the future';
}

export const validateTextField = (data: {
  value: string;
  regex?: string | null;
  required: boolean;
  fieldName: string;
  validationExample?: string | null;
}) => {
  const { value, regex, required, validationExample } = data;
  if (required && !value) {
    return 'Required';
  }
  if (regex && value) {
    if (new RegExp(regex).test(value)) {
      return undefined;
    } else {
      return `${value} doesn't match validation rule ${regex}. Example: ${validationExample}`;
    }
  }
};

export const validateRegex = (regex: string, validationExample?: string) => (value: string) => {
  if (new RegExp(regex).test(value)) {
    return undefined;
  }
  return `${value} doesn't match validation rule ${regex}. Example: ${validationExample}`;
};

export const validateMasterPartTemplate = (template?: MasterPartTemplateDetailsModel | OdataMasterPartTemplates) => {
  if (template?.masterPartTemplateType === 'MIR') {
    return 'Must not select MIR template';
  }

  return undefined;
};
